import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InventorizationStatusesList } from './InventorizationStatusesList';

interface InventorizationGridDialogProps {
  open: boolean;
  onClose: () => void;
  terminalId: number;
}

export const InventorizationGridDialog: React.FC<InventorizationGridDialogProps> = ({
  open,
  onClose,
  terminalId,
}) => {
  const translate = useTranslate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperProps={{ style: { height: '90vh' } }}>
      <DialogTitle>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">{translate('osfc.inventorization.grid.title')}</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '8px 24px 24px', flex: 1 }}>
        <InventorizationStatusesList terminalId={terminalId} />
      </DialogContent>
    </Dialog>
  );
};
